import { Informations, Service, Price, Rules, Contact, Navlink, Education } from "../globaltypes";

export const INFORMATIONS: Informations = {
  name: "Rácz Imre",
  jobName1: "Gyógytornász-Fizioterapeuta",
  jobName2: "Manuálterapeuta",
  aboutMe1:
    "Rácz Imre vagyok gyógytornász-fizioterapeuta, manuálterapeuta. 2017-ben végeztem a Debreceni Egyetem Népegészségügyi Karán, gyógytornász szakirányon. Azóta tapasztalatot szereztem több klinikai területen, mint mozgásszervi rehabilitáció, traumatológia, ortopédia, reumatológia, neurológia és gyermekrehabilitáció. 2024-ben a Semmelweis Egyetem Általános Orvostudományi Karán Manuálterápiából tettem eredményes záróvizsgát, aminek köszönhetően még nagyobb szakmai felkészültséggel tudok segíteni a hozzám forduló pácienseknek.",
  aboutMe2:
    "A kezelések minden esetben egy alapos állapotfelmérést követően, egyénre szabottan és komplex módon történnek, legyen szó a támasztó és mozgatórendszer különböző bántalmairól, műtét utáni rehabilitációról, neurológiai betegségekről, vagy az állóképesség fejlesztéséről.",
  aboutMe3:
    "Alapelvem, hogy a pácienssel együttműködve, fokozatosan érjük el a kitűzött célt és mindenkit a saját állapotához, képességeihez mérten állítsak a fejlődés útjára, hogy mihamarabb visszatérhessen a hétköznapi tevékenységeihez, munkájához vagy szeretett sportjához.",
};

export const SERVICES: Service[] = [
  {
    name: "Egyéni gyógytorna",
    description:
      "Mozgásszervi problémák kezelésére és megelőzésére szolgál, segíti a betegek mozgásképességének javulását, fenntartását. Részét képezi a mozgásszervi állapotfelmérés, az egyéni fizioterápiás célok meghatározása, a műtétek és sérülések utáni rehabilitáció, a támasztó és mozgatórendszert érintő elváltozások kezelése, a neurológiai rehabilitáció, a kondicionálás és erősités, valamint a prevenció.",
    image: "/Physio.jpg",
  },
  {
    name: "Manuálterápia",
    description:
      "Azoknak a diagnosztikai és kezelési módszereknek az összessége, mely a támasztó és mozgató rendszer visszafordítható zavarainak vizsgálatával és kezelésével foglalkozik. A terapeuta manuális technikák alkalmazásával törekszik a funkció helyreállitására, legyen szó a gerinc vagy a végtagok ízületeiről, vagy az izomzat elváltozásairól.",
    image: "/Manual.jpg",
  },
  {
    name: "Schroth torna",
    description:
      "Egy speciális, a gerincferdülés (scoliosis) kezelésére kifejlesztett rehabilitációs módszer, amely a gerinc deformitásának javítására, a fájdalom enyhítésére, a testtartás korrekciójára, valamint az izomzat erősitésére összpontosít.",
    image: "/Schroth.jpg",
  },
  {
    name: "McKenzie módszer",
    description:
      "Az egyik legelterjedtebb terápiás eljárás a gerinc bántalmainak (pl. porckorongsérv) kezelésére. Alapos vizsgálatot követően határozzuk meg azokat az egyénre szabott gyakorlatokat melyek csökkentik a páciens panaszait, jelentsen ez lokális, vagy végtagba kisugárzó fájdalmat, vagy mozgásbeszűkülést. A beteg aktívan részt vesz a kezelésben és otthonában végzi a kiadott feladatokat a terapeuta rendszeres kontrolljával.",
    image: "/McKenzie.jpg",
  },
  {
    name: "Kinesio Tape",
    description:
      "Egy rugalmas tapasz, ami az izmok, ínak és az ízületek sérülései vagy gyulladása esetén segíti azok funkcióját, működésbeli helyreállását.",
    image: "/Kinesio.jpg",
  },
];

export const PRICES: Price[] = [
  {
    serviceName: "Egyéni gyógytorna - Első alkalom (Állapotfelmérés)",
    price: 14000,
  },
  {
    serviceName: "Egyéni gyógytorna 30 perc",
    price: 8000,
  },
  {
    serviceName: "Egyéni gyógytorna 50 perc",
    price: 10000,
  },
  {
    serviceName: "Manuálterápia - Első alkalom (Állapotfelmérés + kezelés)",
    price: 24000,
  },
  {
    serviceName: "Manuálterápia - További kezelések",
    price: 12000,
  },
];

export const RULES: Rules = {
  title1: "Tudnivalók",
  title2: "Késés, lemondás, fizetés",
  description: [
    "A terápiák előre egyeztetett időpontban történnek, időpontot a kapcsolat menüpontban található elérhetőségeken (telefon, email) tud kérni.",
    "Tisztelettel kérem minden páciensemet, hogy időben érkezzenek, várakozásra a bolt előterében van lehetőség.",
    "Az időpont lemondását legkésőbb a kezelés időpontja előtt 24 órával kérem jelezni. Ennél későbbi lemondás esetén a kezelés díjának térítése után tudok új időpontot adni.",
    "A terápiák díját készpénzzel és átutalással van lehetőség rendezni.",
  ],
  image: "",
};

export const CONTACT: Contact = {
  email: "raczimregyogytorna@gmail.com",
  mobile: "+36305992038",
  address1: "4026 Debrecen Mester utca 7.",
  address2: "(Gyógyászati segédeszköz bolt)",
};

export const NAVLINKS: Navlink[] = [
  {
    url: "#aboutme",
    label: "Rólam",
  },
  {
    url: "#services",
    label: "Szolgáltatások",
  },
  {
    url: "#prices",
    label: "Árak",
  },
  {
    url: "#knowhow",
    label: "Tudnivalók",
  },
  {
    url: "#contact",
    label: "Kapcsolat",
  },
];

export const EDUCATION: Education[] = [
  {
    year: "2024",
    school: "Semmelweis Egyetem - Általános Orvostudományi Kar",
    name: "Manuálterápia",
  },
  {
    year: "2018",
    school: "McKenzie Magyarország Intézet",
    name: "Mckenzie „A” Kurzus - Lumbalis gerinc ",
  },
  {
    year: "2018",
    school: "SpineArt Továbbképzési Központ",
    name: "3D Scoliosis Terápia a Schroth rendszer alapján Tanfolyam I-II.",
  },
  {
    year: "2017",
    school: "Debreceni Egyetem - Népegészségügyi Kar - Fizioterápiás Tanszék",
    name: "Gyógytornász-Fizioterapeuta (BSc)",
  },
  {
    year: "2016",
    school: "All-right Bt",
    name: "Kinematic Taping Alaptanfolyam",
  },
];
